'use strict';

var React = require('react'),
    Icon = require('../atoms/Icon'),
    Link = require('../atoms/Link'),
    PureRenderMixin = require('../mixins/PureRenderMixin');

var ContactUs = React.createClass({
  mixins: [PureRenderMixin],

  propTypes: {
    onCloseClick: React.PropTypes.func.isRequired
  },

  render: function () {
    return (
      <div className='Modal-body Modal-body--wide'>
        <div className='Modal-header'>
          <h3 className='Modal-title'>
            Contact Us
          </h3>
          <div onTouchTap={this.props.onCloseClick} className='Modal-close'>
            <Icon name='cross' size='small' mode='stroke' />
          </div>
        </div>
        <div className='Modal-content'>
          <p className='Modal-message'>
            If you find an issue or have a suggestion for how we can make Stampsy better, let us know! You can either email us at <Link bold href='mailto:hello@stampsy.com' target='_blank'>hello@stampsy.com</Link>, or click <b>“Send Feedback”</b> in the profile menu in the upper right corner when you’re logged in.
          </p>

          <p className='Modal-message'>
            For press requests, additional information and high resolution imagery, contact Serious Business: <Link bold href='mailto:info@seriousbusinesspr.com' target='_blank'>info@seriousbusinesspr.com</Link>, +1.646-559-2248.
          </p>
        </div>
      </div>
    );
  }
});

module.exports = ContactUs;


/** WEBPACK FOOTER **
 ** ./modals/ContactUs.jsx
 **/